export const getPageTypeFromRouteName = (routeName) => {
    if (!routeName) {
        return '';
    }
    
    if (routeName.startsWith('pricing')) {
        return 'pricing';
    } else if (routeName.startsWith('browse')) {
        return 'browse';
    } else if (routeName === 'account-login') {
        return 'login';
    } else if (routeName.startsWith('account')) {
        return 'account';
    } else if (routeName.startsWith('sign-up')) {
        return 'sign-up';
    } else if (routeName === 'category-product') {
        return 'product-details';
    } else if (['home', 'index'].includes(routeName)) {
        return 'home';
    }

    return routeName;
}